// extracted by mini-css-extract-plugin
export default {"PreparingForJLPT_container":"PreparingForJLPT_PreparingForJLPT_container__RYnqB","PreparingForJLPT_box":"PreparingForJLPT_PreparingForJLPT_box__Vam+W"};